import { Grid, Typography } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { TypographyProps } from "@mui/material/Typography";
import { createStyles, CSSProperties, withStyles, WithStyles } from "@mui/styles";
import { GlobalClassKeys } from "assets/jss/common-styles";
import colorsStyle from "assets/jss/mui-extras/colorsStyle";
import classNames from 'classnames';
import IconButtonClose from "components/Buttons/IconButtonClose";
import MuiColor from "components/MuiExtras/Typography/MuiColor";
import * as React from "react";


const style = (theme: Theme) => {

    const { mutedDark } = colorsStyle(theme);

    return createStyles({

        root: {
            textAlign: "left",
            marginBottom: theme.spacing(1)
        },

        rootBorder: {
            borderBottom: "solid",
            borderBottomWidth: "1px",
            borderBottomColor: (mutedDark as CSSProperties).color,
        },

        titleContainer: {
            "& h6": {
                lineHeight: "normal",
                textTransform: "uppercase"
            }
        },

    });
}

interface IProps {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    onClose?: () => void;
}

type Props = Omit<TypographyProps, "title" | "ref"> & IProps & WithStyles<typeof style>;

const MuiWidgetTitle: React.FC<Props> = (props) => {
    const { classes, children, title, subtitle, onClose, ...rest } = props;

    const c = classNames({
        [classes.root]: true,
        [classes.rootBorder]: title != null || subtitle != null
    });

    return (
        <div>
            <div className={c} >
                <Grid container justifyContent="center" >
                    <Grid item className={GlobalClassKeys.grow}>
                        <div className={classes.titleContainer}>
                            <MuiColor variant="mutedDark">
                                <Typography color="inherit" component="div" noWrap variant="h6" {...rest}>{title}</Typography>
                                {subtitle && <Typography color="inherit" component="div" noWrap variant="subtitle1">{subtitle}</Typography>}
                            </MuiColor>
                        </div>
                    </Grid>
                    {
                        onClose &&
                        <Grid item>
                            <IconButtonClose size="small" onClick={onClose} />
                        </Grid>
                    }
                </Grid>
            </div>
        </div>
    );
}

export default withStyles(style)(MuiWidgetTitle);
